export default "<div class=\"content-wrapper\">\n  <div *ngFor=\"let item of items\">\n    {{ key && key.length > 0 ? item[key] : item }}\n  </div>\n</div>"